<template>
  <v-layout column :justify-space-between="$vuetify.breakpoint.xsOnly" :justify-start="$vuetify.breakpoint.smAndUp" fill-height>
    <v-form @keyup.enter.prevent="checkWristband()">
      <v-text-field
        :label="$t('tagId.label')"
        autofocus
        box
        dark
        class="flex-none"
        color="white"
        autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
        prepend-inner-icon="nfc" append-icon="info_outline"
        @click:append="showInfo = !showInfo"
        v-model="tagId"
        :error-messages="formErrors ? formErrors.data : ''"
        @keyup.enter.prevent="checkWristband()"
      ></v-text-field>
      <v-text-field
        style="display: none;"
      ></v-text-field>
      <info-modal :triggerOpen="showInfo" content="modal-info-tag-id">
        <modal-info-tag-id slot="content"></modal-info-tag-id>
      </info-modal>
    </v-form>
    <v-flex class="flex-none pa-0">
      <v-btn :loading="state.loading" style="float: right" :block="$vuetify.breakpoint.xsOnly" color="secondary blue-grey--text text--darken-2" round large :class="{'mt-5': $vuetify.breakpoint.smAndUp}" @click="checkWristband()">{{$t('tagId.validate')}}</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
/* global luhn */
import routeNames from '@/router/route-names'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      routeNames,
      tagId: null,
      showInfo: false,
      formErrors: null
    }
  },
  components: {
    InfoModal: require('@/components/Modals/InfoModal').default,
    ModalInfoTagId: require('@/components/Modals/ModalContent/TagIDInfo').default
  },
  computed: {
    ...mapState(['state', 'data'])
  },
  methods: {
    checkWristband () {
      if (this.validateId()) {
        this.$store.dispatch('getUserData', this.tagId).then(() => {
          this.$emit('nextStep')
        }).catch((err) => {
          if (err.status === 404) {
            this.formErrors = {}
            this.formErrors.data = this.$t('error.not_found.tag')
          }
        })
      }
    },
    validateId () {
      this.formErrors = {}
      if (this.tagId && this.tagId.match(/\b[0-9A-F]{15}\b/gi)) {
        var tagId = this.tagId.slice(0, -1)
        var decimalTagId = parseInt(tagId, 16)
        var checkdigit = this.tagId.slice(-1)
        var isValid = luhn(decimalTagId.toString().concat(checkdigit))
        if (isValid) {
          return true
        } else {
          this.formErrors = {}
          this.formErrors.data = this.$t(
            'error.bad_request.string.invalid_tag'
          )
          return false
        }
      } else if (this.tagId && this.tagId.match(/\b[0-9A-F]{14}\b/gi)){
        return true
      } else if (!this.tagId) {
        this.formErrors.data = this.$t('error.bad_request.string.base')
        return false
      } else {
        this.formErrors.data = this.$t('error.bad_request.string.min')
        return false
      }
    }
  },
  created () {
    if (this.data.tagId) {
      this.tagId = this.data.tagId
    }
  },
  mounted () {
    // eslint-disable-next-line
    !function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n;n="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,n.luhn=e()}}(function(){return function e(n,r,t){function o(u,i){if(!r[u]){if(!n[u]){var d="function"==typeof require&&require;if(!i&&d)return d(u,!0);if(f)return f(u,!0);var l=new Error("Cannot find module '"+u+"'");throw l.code="MODULE_NOT_FOUND",l}var p=r[u]={exports:{}};n[u][0].call(p.exports,function(e){var r=n[u][1][e];return o(r?r:e)},p,p.exports,e,n,r,t)}return r[u].exports}for(var f="function"==typeof require&&require,u=0;u<t.length;u++)o(t[u]);return o}({1:[function(e,n,r){"use strict";Object.defineProperty(r,"__esModule",{value:!0}),r.default=function(e){return function(n){for(var r=n?n.length:0,t=1,o=0;r--;)o+=(t^=1)?e[n[r]]:parseInt(n[r],10);return o%10===0&&o>0}}([0,2,4,6,8,1,3,5,7,9]),n.exports=r.default},{}]},{},[1])(1)});
  }
}
</script>
